import { Check } from "lucide-react";
import { SITE, PRODUCT_IMAGES } from "@/config";
import { BuyButton } from "@/components/BuyButton";
import { ProductImage } from "@/components/ProductImage";
import { Reveal } from "@/lib/motion";

const INCLUDES = [
  "Premium glossy PVC countertop stand",
  "100 × 150 mm display",
  "NTAG215 NFC technology",
  "Configured for your business",
  "Works with compatible iPhone & Android devices",
  "No app required",
  "No subscription",
  "Reprogrammable NFC",
];

export const Purchase = () => (
  <section id="buy" className="scroll-mt-24 bg-sand py-24 md:py-32" data-testid="purchase-section">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="grid grid-cols-1 gap-6 overflow-hidden rounded-[2rem] border border-black/5 bg-white shadow-[0_20px_60px_rgba(0,0,0,0.06)] lg:grid-cols-2">
        {/* image */}
        <Reveal className="p-6 md:p-8">
          <ProductImage
            src={PRODUCT_IMAGES.purchase}
            alt="Tap Review NFC Google Review countertop stand"
            ratio="aspect-square lg:aspect-auto lg:h-full lg:min-h-[520px]"
            testId="purchase-product-image"
          />
        </Reveal>

        {/* details */}
        <Reveal delay={0.1} className="flex flex-col justify-center p-8 md:p-12">
          <p className="text-overline">One-time purchase</p>
          <h2 className="mt-3 font-display text-3xl font-medium tracking-tight text-ink sm:text-4xl">
            Tap Review NFC Stand
          </h2>
          <p className="mt-4 font-display text-4xl font-semibold tracking-tight text-ink">
            {SITE.price}
          </p>
          <p className="mt-1 text-sm text-graphite/75">+ £4.99 shipping · one-time purchase</p>

          <ul className="mt-8 grid grid-cols-1 gap-y-3 sm:grid-cols-2 sm:gap-x-6">
            {INCLUDES.map((item) => (
              <li key={item} className="flex items-start gap-2.5">
                <Check className="mt-0.5 h-4 w-4 shrink-0 text-ink" strokeWidth={2.4} />
                <span className="text-sm leading-snug text-graphite">{item}</span>
              </li>
            ))}
          </ul>

          <BuyButton testId="buy-now-purchase" className="mt-9 w-full px-8 py-4 text-base sm:w-auto">
            Buy now — {SITE.price}
          </BuyButton>
          <p className="mt-3 text-xs leading-relaxed text-graphite/75">
            At secure Stripe checkout you'll add your business's Google Review URL
            and can choose your quantity.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
